/* Donotion — interactions + animations. Moteur : Motion (motion.dev). */
(function () {
  'use strict';

  /* ---- DESTINATIONS DES LIENS — tout se règle ici ----
     BASE vide = chemins relatifs : suit le thème, son aperçu et le domaine. */
  var BASE = '';
  var TEMPLATES_URL = BASE + '/collections/all';
  var CONTACT_URL   = BASE + '/pages/forms';
  var PRODUCTS = {
    'freelance-os':   BASE + '/products/freelance-os',
    'second-cerveau': BASE + '/products/second-cerveau',
    'gym-pro-os':     BASE + '/products/gym-pro-os'
  };
  var PAGES = { 'newsletter': BASE + '/pages/newsletter', 'contact': BASE + '/pages/contact' };

  var root = document.documentElement;
  var M = window.Motion;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!M || reduced) { root.classList.add('motion-off'); root.classList.remove('anim-ready'); }
  else { root.classList.add('anim-started'); }

  var EASE = [0.22, 1, 0.36, 1];

  function applyLinks() {
    [['templates', TEMPLATES_URL], ['contact', CONTACT_URL]].forEach(function (pair) {
      var name = pair[0], url = pair[1];
      if (!url) return;
      document.querySelectorAll('[data-link="' + name + '"]').forEach(function (a) { a.setAttribute('href', url); });
    });
    document.querySelectorAll('[data-product]').forEach(function (a) {
      var url = PRODUCTS[a.dataset.product]; if (url) a.setAttribute('href', url);
    });
    document.querySelectorAll('[data-page]').forEach(function (a) {
      var url = PAGES[a.dataset.page]; if (url) a.setAttribute('href', url);
    });
  }

  var VARIANTS = {
    'fade-up':   { opacity: [0, 1], y: [28, 0], scale: [0.985, 1] },
    'fade-left': { opacity: [0, 1], x: [34, 0] },
    'fade-in':   { opacity: [0, 1] }
  };

  function reveals() {
    if (!M || reduced) return;
    var groups = new Map();
    document.querySelectorAll('[data-reveal]').forEach(function (el) {
      if (el.closest('.hero')) return;
      var parent = el.parentElement;
      if (!groups.has(parent)) groups.set(parent, []);
      groups.get(parent).push(el);
    });
    groups.forEach(function (items) {
      items.forEach(function (el, i) {
        M.inView(el, function () {
          var variant = VARIANTS[el.dataset.reveal] || VARIANTS['fade-up'];
          M.animate(el, variant, { duration: 0.68, delay: Math.min(i * 0.075, 0.4), ease: EASE });
          return false;
        }, { amount: 0.15, margin: '0px 0px -8% 0px' });
      });
    });
  }

  function heroIntro() {
    if (!M || reduced) return;
    var copy = document.querySelectorAll('[data-hero]');
    if (copy.length) {
      M.animate(copy, { opacity: [0, 1], y: [24, 0], filter: ['blur(6px)', 'blur(0px)'] },
        { duration: 0.7, delay: M.stagger(0.09, { startDelay: 0.05 }), ease: EASE });
    }
    var stage = document.querySelector('[data-hero-visual]');
    if (stage) M.animate(stage, { opacity: [0, 1], y: [46, 0], scale: [0.97, 1] }, { duration: 1, delay: 0.34, ease: EASE });
    var frame = document.querySelector('[data-frame]');
    if (frame) M.animate(frame, { scale: [0.985, 1] }, { duration: 1.1, delay: 0.4, ease: EASE });
    var items = document.querySelectorAll('[data-app]');
    if (items.length) M.animate(items, { opacity: [0, 1], y: [10, 0] }, { duration: 0.44, delay: M.stagger(0.035, { startDelay: 0.75 }), ease: EASE });
  }

  function stageParallax() {
    if (!M || reduced || !M.scroll) return;
    var app = document.querySelector('.stage .app');
    if (!app || window.innerWidth < 1024) return;
    M.scroll(function (progress) { app.style.transform = 'translateY(' + (progress * -30) + 'px)'; },
      { target: app, offset: ['start end', 'end start'] });
  }

  /* Cartes épinglées : on n'anime que l'opacité, l'inclinaison vient du CSS. */
  function pinnedCards() {
    var els = document.querySelectorAll('[data-pcard]');
    if (!els.length) return;
    if (!M || reduced) { root.classList.add('motion-off'); return; }
    els.forEach(function (el, i) {
      M.inView(el, function () {
        M.animate(el, { opacity: [0, 1] }, { duration: 0.5, delay: Math.min(i * 0.09, 0.45), ease: EASE });
        return false;
      }, { amount: 0.25, margin: '0px 0px -6% 0px' });
    });
  }

  function steps() {
    var els = document.querySelectorAll('[data-step]');
    if (!els.length) return;
    if (!M || reduced) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    els.forEach(function (el, i) {
      M.inView(el, function () { setTimeout(function () { el.classList.add('is-in'); }, i * 130); return false; }, { amount: 0.4 });
    });
  }

  /* Faisceaux animés vers la destination (transposition d'Animated Beam). */
  function beams() {
    var map = document.querySelector('[data-beam-map]');
    if (!map) return;
    var svg = map.querySelector('.funnel__svg');
    var target = map.querySelector('[data-beam-target]');
    var froms = map.querySelectorAll('[data-beam-from]');
    if (!svg || !target || !froms.length) return;
    var SVGNS = 'http://www.w3.org/2000/svg';

    function draw() {
      if (window.innerWidth < 900) { svg.innerHTML = ''; return; }
      var box = map.getBoundingClientRect();
      var t = target.getBoundingClientRect();
      var ex = t.left - box.left;
      var ey = t.top - box.top + t.height / 2;
      svg.setAttribute('viewBox', '0 0 ' + box.width + ' ' + box.height);
      svg.innerHTML = '';
      var defs = document.createElementNS(SVGNS, 'defs');
      svg.appendChild(defs);
      froms.forEach(function (node, i) {
        var r = node.getBoundingClientRect();
        var sx = r.right - box.left;
        var sy = r.top - box.top + r.height / 2;
        var curvature = parseFloat(node.dataset.curvature) || 0;
        var d = 'M ' + sx + ',' + sy + ' Q ' + ((sx + ex) / 2) + ',' + (sy - curvature) + ' ' + ex + ',' + ey;
        var base = document.createElementNS(SVGNS, 'path');
        base.setAttribute('d', d);
        base.setAttribute('stroke', '#96B6F7');
        base.setAttribute('stroke-width', '2');
        base.setAttribute('stroke-opacity', '.8');
        base.setAttribute('fill', 'none');
        base.setAttribute('stroke-linecap', 'round');
        svg.appendChild(base);
        if (reduced) return;
        var id = 'beam-' + i;
        var reverse = node.dataset.side === 'r';
        var grad = document.createElementNS(SVGNS, 'linearGradient');
        grad.setAttribute('id', id);
        grad.setAttribute('gradientUnits', 'userSpaceOnUse');
        grad.innerHTML =
          '<stop offset="0%" stop-color="#2663EB" stop-opacity="0"/>' +
          '<stop offset="8%" stop-color="#2663EB"/>' +
          '<stop offset="32.5%" stop-color="#96B6F7"/>' +
          '<stop offset="100%" stop-color="#96B6F7" stop-opacity="0"/>' +
          '<animate attributeName="x1" values="' + (reverse ? '90%;-10%' : '10%;110%') + '" dur="4.5s" begin="' + (i * 0.45) + 's" repeatCount="indefinite"/>' +
          '<animate attributeName="x2" values="' + (reverse ? '100%;0%' : '0%;100%') + '" dur="4.5s" begin="' + (i * 0.45) + 's" repeatCount="indefinite"/>';
        defs.appendChild(grad);
        var beam = document.createElementNS(SVGNS, 'path');
        beam.setAttribute('d', d);
        beam.setAttribute('stroke', 'url(#' + id + ')');
        beam.setAttribute('stroke-width', '3');
        beam.setAttribute('fill', 'none');
        beam.setAttribute('stroke-linecap', 'round');
        svg.appendChild(beam);
      });
    }

    draw();
    var pending;
    function redraw() { clearTimeout(pending); pending = setTimeout(draw, 120); }
    if (window.ResizeObserver) new ResizeObserver(redraw).observe(map);
    window.addEventListener('resize', redraw, { passive: true });
    window.addEventListener('orientationchange', redraw);
    if (M && M.inView) M.inView(map, function () { draw(); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(draw);
  }

  function faq() {
    var items = document.querySelectorAll('.faq-item');
    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        items.forEach(function (other) { if (other !== item) other.open = false; });
      });
    });
  }

  function runAnimations() { steps(); pinnedCards(); reveals(); heroIntro(); stageParallax(); }

  function init() {
    applyLinks();
    faq();
    beams();
    if (document.hidden) {
      document.addEventListener('visibilitychange', function onVisible() {
        if (document.hidden) return;
        document.removeEventListener('visibilitychange', onVisible);
        runAnimations();
      });
    } else { runAnimations(); }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
